import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import '../styles/Home.css';

const Home = () => {
    const [userInfo, setUserInfo] = useState(null);
    const [clientRoles, setClientRoles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('adminToken');
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                const username = localStorage.getItem('adminUsername');

                const resourceAccess = decodedToken.resource_access || {};
                const mlStudioRoles = resourceAccess.ml_studio?.roles || [];

                setUserInfo({
                    username: username,
                    userId: decodedToken.sub,
                    email: decodedToken.email || decodedToken.preferred_username || 'Not provided',
                    loginTime: new Date(decodedToken.iat * 1000).toLocaleString(),
                    expiryTime: new Date(decodedToken.exp * 1000).toLocaleString(),
                });

                setClientRoles(mlStudioRoles);
            } catch (error) {
                console.error('Error decoding token:', error);
            }
        }
        setLoading(false);
    }, []);

    const isSuperAdmin = clientRoles.includes('SuperAdmin');
    const isAdmin = clientRoles.includes('Admin');

    if (loading) {
        return (
            <div className="home-container">
                <div className="loading-spinner">Loading...</div>
            </div>
        );
    }

    return (
        <div className="home-container">
            <div className="card full-width-card">
                <div className="card-header card-header-tertiary">
                    <h5>Available Features</h5>
                </div>
                <div className="card-body">
                    <div className="features-grid">
                        <div className="feature-item">
                            <span className="feature-icon">🔑</span>
                            <h6>API Key Management</h6>
                            <p>Generate, manage, and delete API keys for users</p>
                        </div>
                        <div className="feature-item">
                            <span className="feature-icon">⚙️</span>
                            <h6>Model Configuration</h6>
                            <p>Configure model settings and parameters</p>
                        </div>
                        <div className="feature-item">
                            <span className="feature-icon">🤖</span>
                            <h6>Model Management</h6>
                            <p>Deploy and manage ML models</p>
                        </div>
                        <div className="feature-item">
                            <span className="feature-icon">📊</span>
                            <h6>Pipeline Management</h6>
                            <p>Create and manage ML pipelines</p>
                        </div>
                        <div className="feature-item">
                            <span className="feature-icon">🔐</span>
                            <h6>Security</h6>
                            <p>Change your password and manage security</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card full-width-card">
                <div className="card-header card-header-info">
                    <h5>Role Information & Permissions</h5>
                </div>
                <div className="card-body">
                    <h6 className="mb-4">Administrative Roles</h6>
                    <div className="roles-grid">
                        <div className="role-card">
                            <h6 className="role-title">👑 SuperAdmin</h6>
                            <p className="role-desc">
                                Highest level of access with full control over the platform. Can manage all users, assign/revoke roles, and perform all administrative tasks.
                            </p>
                        </div>
                        <div className="role-card">
                            <h6 className="role-title">👤 Admin</h6>
                            <p className="role-desc">
                                Administrative access to manage users and standard features. Can create users but cannot manage other admins.
                            </p>
                        </div>
                    </div>

                    <h6 className="mb-4 mt-5">Feature Roles</h6>
                    <div className="feature-roles-grid">
                        <div className="feature-role-item">
                            <h6>📊 Pipeline Manager</h6>
                            <small>Model training and export operations</small>
                        </div>
                        <div className="feature-role-item">
                            <h6>🤖 Deployment Manager</h6>
                            <small>Model deployment and batch predictions</small>
                        </div>
                        <div className="feature-role-item">
                            <h6>⚙️ Process Manager</h6>
                            <small>Running pipelines and cleanup</small>
                        </div>
                        <div className="feature-role-item">
                            <h6>🔧 Model Training</h6>
                            <small>Train and manage ML models</small>
                        </div>
                        <div className="feature-role-item">
                            <h6>💾 Model Export</h6>
                            <small>Export trained models</small>
                        </div>
                        <div className="feature-role-item">
                            <h6>📡 Batch Inference</h6>
                            <small>Run batch predictions</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
